import {
  add_money,
  help,
  status_failed,
  status_process,
  status_success,
  txn_fail,
  txn_process,
  txn_success,
  withdraw_money,
} from "../../utils/images";
import { Color } from "../../assets";

export const PASSBOOK_LIMIT = 10;

export const WALLET_OPTION = [
  {
    title: "Add",
    titleImg: add_money,
  },
  {
    title: "Withdraw",
    titleImg: withdraw_money,
  }
];

export const WALLET_TRANSACTION_STATUS = {
  C: {
    icon: status_success,
    title:
      "Your last {typeOfRequest} of  {amount} has been successfully processed.",
    color: "rgba(0, 170, 81, 0.1)",
    colorText: "rgba(0, 170, 81, 1)",
    borderColor: "rgba(0, 170, 81, 1)",
  },
  A: {
    icon: status_process,
    title:
      "Your {typeOfRequest} of  {amount} is in processing. Funds will be credited to your account within 24 hours.",
    borderColor: "rgba(255, 220, 93, 1)",
    color: "rgba(255, 220, 93, 0.1)",
    colorText: Color.black,
  },
  CAN: {
    icon: status_failed,
    title:
      "Your previous {typeOfRequest} request of  {amount} has failed. Our support team can assist with your queries.",
    color: "rgba(168, 32, 13, 0.1)",
    borderColor: "rgba(168, 32, 13, 1)",
    colorText: Color.black,
  },
  CN: {
    icon: status_failed,
    title:
      "Your previous {typeOfRequest} request of  {amount} has failed. Our support team can assist with your queries.",
    color: "rgba(168, 32, 13, 0.1)",
    borderColor: "rgba(168, 32, 13, 1)",
    colorText: Color.black,
  },
};

export const DEPOSIT_VAL = ["100", "500", "1000", "5000"];
export const DEPOSIT_VAL_INTERNATIONAL = ["50", "100", "200", "500"];

export const ON_META_STATUS_PASS = [
  "completed",
  "expired",
  "cancelled",
  "refunded",
];
